import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import { Button } from './ui/button';

const YelpIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.054 6.027c.259.462.542 1.047 1.043 1.286a1.058 1.058 0 00.101.038c.225.085.47.102.704.047l.042-.01a1.214 1.214 0 00.566-.34 1.103 1.103 0 00.079-.082c.346-.435.345-1.083.376-1.613.104-1.771.214-3.542.301-5.314.033-.671.106-1.333.066-2.01C14.298-2.53 14.294-3.17 13.942-3.628c-.622-.807-1.948-.741-2.852-.616a8.672 8.672 0 00-.83.156c-.276.066-.549.138-.815.224-.868.284-2.088.806-2.295 1.806-.116.566.16 1.144.374 1.66.26.626.614 1.19.937 1.778.854 1.555 1.725 3.1 2.593 4.647z" transform="translate(0 2)"/>
    <path d="M7.689 15.142l-3.672.848c-.377.087-.755.183-1.145.155-.261-.019-.512-.041-.761-.213a1.179 1.179 0 01-.331-.36c-.349-.551-.366-1.366-.37-2a6.287 6.287 0 01.332-2.064c.03-.085.066-.168.107-.247a2.343 2.343 0 01.126-.217 2.457 2.457 0 01.156-.197 1.174 1.174 0 01.399-.283 1.082 1.082 0 01.46-.084c.235.002.513.052.91.173l.185.057c.328.101.705.24 1.15.399.686.24 1.366.487 2.046.74l1.212.442c.222.081.436.18.641.297.174.098.327.23.451.387a1.217 1.217 0 01.192.431 1.22 1.22 0 01-.872 1.452l-.109.03-1.105.255z" transform="translate(0 2)"/>
    <path d="M18.821 7.565a1.851 1.851 0 00-.204-.175 2.408 2.408 0 00-.208-.14 2.361 2.361 0 00-.227-.109 1.17 1.17 0 00-.482-.08 1.086 1.086 0 00-.45.127c-.21.105-.439.273-.742.555l-.142.133c-.25.235-.529.525-.86.863a114.636 114.636 0 00-1.517 1.563l-.896.93a4.19 4.19 0 00-.447.548 1.541 1.541 0 00-.236.546 1.22 1.22 0 00.01.452l.005.02a1.218 1.218 0 001.418.923 1.162 1.162 0 00.111-.021l4.778-1.104c.377-.087.759-.167 1.097-.363.227-.132.443-.262.591-.525a1.18 1.18 0 00.14-.469c.074-.651-.266-1.39-.54-1.963a6.279 6.279 0 00-1.2-1.71z" transform="translate(0 2)"/>
    <path d="M11.054 15.95a1.105 1.105 0 00-1.23-.414 1.14 1.14 0 00-.153.063 1.481 1.481 0 00-.217.135c-.2.148-.367.34-.52.532l-.12.156-.769 1.057a113.917 113.917 0 00-1.291 1.79c-.278.389-.518.718-.708 1.009l-.108.165c-.228.352-.357.609-.423.838a1.095 1.095 0 00-.046.472c.021.166.077.325.164.467.046.072.096.141.149.207a2.334 2.334 0 00.175.183c.065.06.135.118.21.173.531.369 1.112.634 1.723.839a6.096 6.096 0 001.571.3c.091.005.182.003.273-.006a2.388 2.388 0 00.251-.035 2.386 2.386 0 00.245-.071 1.193 1.193 0 00.417-.266c.113-.113.2-.249.254-.399.089-.221.148-.503.186-.92l.018-.196c.03-.346.044-.753.067-1.232.037-.735.067-1.468.09-2.202l.05-1.306c.011-.3.002-.634-.082-.934a1.396 1.396 0 00-.176-.405z" transform="translate(0 2)"/>
    <path d="M19.73 18.044c-.16-.176-.388-.351-.746-.568l-.168-.101c-.299-.18-.658-.368-1.078-.597a120.762 120.762 0 00-1.943-1.042l-1.151-.61-.177-.088c-.221-.106-.456-.205-.699-.25a1.492 1.492 0 00-.255-.027 1.153 1.153 0 00-.165.01 1.108 1.108 0 00-.922.914c-.01.145.003.294.016.439.056.306.193.61.334.875l.615 1.153c.342.65.689 1.296 1.044 1.94.229.42.42.78.598 1.078l.101.168c.217.358.392.584.569.746.115.11.252.195.403.247a.861.861 0 00.492.055 2.368 2.368 0 00.251-.044c.082-.022.162-.048.241-.078a1.863 1.863 0 00.248-.114 6.102 6.102 0 001.282-.96c.46-.452.866-.945 1.182-1.51.044-.08.082-.163.114-.248a2.49 2.49 0 00.077-.241c.019-.083.033-.167.043-.251a1.188 1.188 0 00-.057-.491 1.093 1.093 0 00-.248-.404z" transform="translate(0 2)"/>
  </svg>
);

const navData = {
  services: {
    label: 'Services',
    items: [
      { name: 'Home Insurance', path: '/services/home-insurance' },
      { name: 'Auto Insurance', path: '/services/auto-insurance' },
      { name: 'Business Insurance', path: '/services/business-insurance' },
      { name: 'General Liability', path: '/services/general-liability' },
      { name: 'Workers\' Comp', path: '/services/workers-comp' },
      { name: 'Landlord Insurance', path: '/services/landlord-insurance' },
      { name: 'RV Insurance', path: '/services/rv-insurance' },
    ],
  },
  locations: {
    label: 'Locations',
    items: [
      { name: 'North Augusta, SC', path: '/locations/north-augusta-sc' },
      { name: 'Aiken, SC', path: '/locations/aiken-sc' },
      { name: 'Columbia, SC', path: '/locations/columbia-sc' },
      { name: 'Greenville, SC', path: '/locations/greenville-sc' },
      { name: 'Charleston, SC', path: '/locations/charleston-sc' },
      { name: 'Augusta, GA', path: '/locations/augusta-ga' },
      { name: 'Evans, GA', path: '/locations/evans-ga' },
      { name: 'Martinez, GA', path: '/locations/martinez-ga' },
      { name: 'Grovetown, GA', path: '/locations/grovetown-ga' },
      { name: 'Atlanta, GA', path: '/locations/atlanta-ga' },
    ],
  },
  loanGuides: {
    label: 'Loan Guides',
    items: [
      { name: 'VA Loan Insurance', path: '/loan-guides/va-loan' },
      { name: 'FHA Loan Insurance', path: '/loan-guides/fha-loan' },
      { name: 'Conventional Loan', path: '/loan-guides/conventional-loan' },
      { name: 'USDA Loan', path: '/loan-guides/usda-loan' },
    ],
  },
  about: {
    label: 'About',
    items: [
      { name: 'Meet Our Team', path: '/meet-our-team' },
      { name: 'Why Independent', path: '/we-are-independent' },
      { name: 'Insurance Carriers', path: '/insurance-companies' },
      { name: 'Reviews', path: '/review-our-agency' },
      { name: 'Service. Integrity. Leadership.', path: '/founder-letter' },
      { name: 'Mobile App', path: '/mobile-app' },
      { name: 'Referral Partner', path: '/referral/login' },
    ],
  },
};

const DropdownMenu = ({ label, items, isOpen, onToggle, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={onToggle}
        className="flex items-center gap-1 text-[#101C47] hover:text-[#f92626] transition-colors font-medium text-sm py-3"
        data-testid={`nav-dropdown-${label.toLowerCase().replace(/\s/g, '-')}`}
      >
        {label}
        <ChevronDown size={16} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-56 bg-white rounded-lg shadow-xl border border-gray-100 py-2 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
          {items.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={onClose}
              className="block px-4 py-3 text-sm text-gray-700 hover:bg-[#f92626]/5 hover:text-[#f92626] transition-colors"
              data-testid={`nav-link-${item.path.replace(/\//g, '-').slice(1)}`}
            >
              {item.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileExpanded, setMobileExpanded] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobile = () => {
    setMobileMenuOpen(false);
    setMobileExpanded(null);
  };

  return (
    <nav
      className={`sticky top-0 z-50 bg-white transition-shadow duration-300 ${scrolled ? 'shadow-lg' : 'shadow-md'}`}
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16 gap-8">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0" data-testid="header-logo">
            <picture>
              <source srcSet="/tqi-logo-color.webp" type="image/webp" />
              <img
                src="/tqi-logo-color.png"
                alt="Total Quality Insurance - Veteran-Owned Agency in Augusta GA"
                className="h-10 w-auto"
                width="160"
                height="40"
                fetchPriority="high"
              />
            </picture>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-5 flex-1">
            {Object.entries(navData).map(([key, { label, items }]) => (
              <DropdownMenu
                key={key}
                label={label}
                items={items}
                isOpen={openDropdown === key}
                onToggle={() => setOpenDropdown(openDropdown === key ? null : key)}
                onClose={() => setOpenDropdown(null)}
              />
            ))}
            <Link
              to="/clickable-coverage"
              className="text-[#101C47] hover:text-[#f92626] transition-colors font-medium text-sm"
              data-testid="nav-link-clickable-coverage"
            >
              Clickable Coverage
            </Link>
            <Link
              to="/resources"
              className="text-[#101C47] hover:text-[#f92626] transition-colors font-medium text-sm"
              data-testid="nav-link-resources"
            >
              Resources
            </Link>
            <Link
              to="/blog"
              className="text-[#101C47] hover:text-[#f92626] transition-colors font-medium text-sm"
              data-testid="nav-link-blog"
            >
              Blog
            </Link>
            <div className="ml-auto flex items-center gap-4">
              <div className="hidden xl:flex items-center gap-2">
                <a href="https://www.facebook.com/TQIAgency" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="header-social-facebook" className="text-[#101C47]/60 hover:text-[#1877F2] transition-colors"><Facebook size={16} /></a>
                <a href="https://www.instagram.com/tqiagency/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="header-social-instagram" className="text-[#101C47]/60 hover:text-[#E4405F] transition-colors"><Instagram size={16} /></a>
                <a href="https://www.linkedin.com/company/total-quality-insurance" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="header-social-linkedin" className="text-[#101C47]/60 hover:text-[#0A66C2] transition-colors"><Linkedin size={16} /></a>
                <a href="https://www.yelp.com/biz/total-quality-insurance-north-augusta" target="_blank" rel="noopener noreferrer" aria-label="Yelp" data-testid="header-social-yelp" className="text-[#101C47]/60 hover:text-[#FF1A1A] transition-colors"><YelpIcon size={16} /></a>
                <a href="https://www.youtube.com/@TQIAgency" target="_blank" rel="noopener noreferrer" aria-label="YouTube" data-testid="header-social-youtube" className="text-[#101C47]/60 hover:text-[#FF0000] transition-colors"><Youtube size={16} /></a>
              </div>
              <a href="tel:706-434-8184" className="hidden xl:flex items-center gap-1.5 text-[#101C47] font-semibold text-sm">
                <Phone size={14} className="text-[#f92626]" />
                706-434-8184
              </a>
              <Link to="/get-a-quote">
                <Button size="sm" className="bg-[#d32f2f] hover:bg-[#c62828] text-white" data-testid="header-get-quote-btn">
                  Start My Quote →
                </Button>
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden text-[#101C47] p-2 ml-auto"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
            aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t max-h-[80vh] overflow-y-auto" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-1">
            {Object.entries(navData).map(([key, { label, items }]) => (
              <div key={key}>
                <button
                  onClick={() => setMobileExpanded(mobileExpanded === key ? null : key)}
                  className="w-full flex justify-between items-center text-[#101C47] hover:text-[#f92626] transition-colors py-3 font-medium"
                >
                  {label}
                  <ChevronDown
                    size={18}
                    className={`transition-transform duration-200 ${mobileExpanded === key ? 'rotate-180' : ''}`}
                  />
                </button>
                {mobileExpanded === key && (
                  <div className="pl-4 pb-2 space-y-1 border-l-2 border-[#f92626]/20 ml-2">
                    {items.map((item) => (
                      <Link
                        key={item.path}
                        to={item.path}
                        onClick={closeMobile}
                        className="block py-2 text-sm text-gray-600 hover:text-[#f92626] transition-colors"
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <Link
              to="/clickable-coverage"
              onClick={closeMobile}
              className="block text-[#101C47] hover:text-[#f92626] transition-colors py-3 font-medium"
            >
              Clickable Coverage
            </Link>
            <Link
              to="/resources"
              onClick={closeMobile}
              className="block text-[#101C47] hover:text-[#f92626] transition-colors py-3 font-medium"
            >
              Resources
            </Link>
            <Link
              to="/blog"
              onClick={closeMobile}
              className="block text-[#101C47] hover:text-[#f92626] transition-colors py-3 font-medium"
            >
              Blog
            </Link>
            <Link
              to="/learning-center"
              onClick={closeMobile}
              className="block text-[#101C47] hover:text-[#f92626] transition-colors py-3 font-medium"
            >
              Learning Center
            </Link>
            <a
              href="tel:706-434-8184"
              className="flex items-center gap-2 text-[#101C47] font-semibold py-3"
            >
              <Phone size={18} className="text-[#f92626]" />
              706-434-8184
            </a>
            <div className="flex items-center gap-3 py-3">
              <a href="https://www.facebook.com/TQIAgency" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center text-[#101C47] hover:bg-[#1877F2] hover:text-white transition-all"><Facebook size={18} /></a>
              <a href="https://www.instagram.com/tqiagency/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center text-[#101C47] hover:bg-[#E4405F] hover:text-white transition-all"><Instagram size={18} /></a>
              <a href="https://www.linkedin.com/company/total-quality-insurance" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center text-[#101C47] hover:bg-[#0A66C2] hover:text-white transition-all"><Linkedin size={18} /></a>
              <a href="https://www.yelp.com/biz/total-quality-insurance-north-augusta" target="_blank" rel="noopener noreferrer" aria-label="Yelp" className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center text-[#101C47] hover:bg-[#FF1A1A] hover:text-white transition-all"><YelpIcon size={18} /></a>
              <a href="https://www.youtube.com/@TQIAgency" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center text-[#101C47] hover:bg-[#FF0000] hover:text-white transition-all"><Youtube size={18} /></a>
            </div>
            <Link to="/get-a-quote" onClick={closeMobile}>
              <Button className="w-full bg-[#d32f2f] hover:bg-[#c62828] text-white mt-2">
                Start My Quote →
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
